import { wrapper } from "../../redux";
import Detail from "/components/pages/articles/detail";
import Redis from "/lib/redis";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { newsDetailLogic } from "../../pagesSrrLogic/news";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function ObzoryNaTovaryDetailPage({
  scripts,
  host,
  news,
  isFarkop,
}) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Detail news={news} isFarkop={isFarkop} />
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ params, query, req, resolvedUrl }) => {
    return newsDetailLogic(
      Redis,
      store,
      query,
      req,
      resolvedUrl,
      params,
      "obzory-na-tovary",
      "Обзоры на товары",
      { filterByDomain: false },
    );
  }),
);
